import { CertificacaoProgress } from '../types';
import { PROGRESS_STORAGE_KEY } from './constants';
import { TRILHAS, TrilhaId, mapTrilhas } from './trilhas';

function seededRandom(seed: string): () => number {
  let h = 0;
  for (let i = 0; i < seed.length; i++) {
    h = Math.imul(31, h) + seed.charCodeAt(i) | 0;
  }
  return () => {
    h ^= h >>> 16;
    h = Math.imul(h, 0x45d9f3b);
    h ^= h >>> 16;
    return (h >>> 0) / 4294967296;
  };
}

function genPct(rng: () => number): number {
  const roll = rng();
  if (roll < 0.15) return 0;
  if (roll < 0.25) return Math.floor(rng() * 70);
  if (roll < 0.55) return 70 + Math.floor(rng() * 29);
  return 100;
}

export function generateMockProgress(login: string): CertificacaoProgress {
  const rng = seededRandom(login);
  const trilhaProgress: Record<TrilhaId, number> = mapTrilhas(() => genPct(rng));
  const fakeDate = (offsetSeed: number) =>
    new Date(Date.now() - offsetSeed * 30 * 24 * 3600000).toISOString();
  const trilhaCertifiedAt: Record<TrilhaId, string | null> = mapTrilhas((trilha) =>
    trilhaProgress[trilha.id] >= 100 ? fakeDate(rng()) : null,
  );
  const anyDone = TRILHAS.some((t) => trilhaProgress[t.id] >= 100);
  const eligibleDone = TRILHAS.some(
    (t) => t.countsForPrizeEligibility && trilhaProgress[t.id] >= 100,
  );
  return {
    login,
    trilhaProgress,
    certifiedAt: anyDone ? fakeDate(rng()) : null,
    prizeCertifiedAt: eligibleDone ? fakeDate(rng()) : null,
    trilhaCertifiedAt,
  };
}

export function loadProgress(logins: string[]): Map<string, CertificacaoProgress> {
  const map = new Map<string, CertificacaoProgress>();
  let saved: Record<string, CertificacaoProgress> = {};
  try {
    const raw = localStorage.getItem(PROGRESS_STORAGE_KEY);
    if (raw) saved = JSON.parse(raw);
  } catch { /* ignore */ }

  for (const login of logins) {
    map.set(login, saved[login] ?? generateMockProgress(login));
  }
  return map;
}

export function saveProgress(map: Map<string, CertificacaoProgress>): void {
  const obj: Record<string, CertificacaoProgress> = {};
  for (const [k, v] of map.entries()) obj[k] = v;
  localStorage.setItem(PROGRESS_STORAGE_KEY, JSON.stringify(obj));
}

export function resetProgress(): void {
  localStorage.removeItem(PROGRESS_STORAGE_KEY);
}
